import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// const firebaseConfig = {
//     apiKey: "AIzaSyClHp90svi4VunHanhXcrrpQn6lYobPBxY",
//     authDomain: "svc-demo-website.firebaseapp.com",
//     projectId: "svc-demo-website",
//     storageBucket: "svc-demo-website.appspot.com",
//     messagingSenderId: "572145565735",
//     appId: "1:572145565735:web:c90e9279b131b0b4264e02"
// }

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
const authProvider = firebase.auth.EmailAuthProvider;
const auth = firebase.auth();

// firebase.firestore().settings({ experimentalForceLongPolling: true });
// firebase.firestore.setLogLevel('debug');

export { db, authProvider, auth, firebase };
